import React, { Fragment, useState } from "react";
import { CircularProgress, Divider } from "@mui/material";
import { useSelector } from "react-redux";
import moment from "moment";
import { CentralModal } from "../CentralModal/CentralModal";
import { getPaymentHistoryService } from "../../../_services";
import "./centralPaymentHistoryModal.css";

export const CentralPaymentHistoryModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paymentData, setPaymentData] = useState([])
  const [isEmptyModal, setIsEmptyModal] = useState(false)
  const reportingData = useSelector(state=>state.centralReportingData?.reportingData);
  const leadId = reportingData?.data ? reportingData?.data[0]?.lead_id: null

  const handleTimeStamp = (value) => {
    try {
      if (!moment(value).isValid()) {
        return '--'
      }
      return moment(value).format("DD MMM, hh:mm A");
    } catch (error) {
      return "--";
    }
  };

  const getHistoryData = () =>{

      const params = {
        "leadId":leadId
      }

      if(leadId){
          setIsEmptyModal(true)
          getPaymentHistoryService(params)
          .then(res=>{
              if(res.status===200 && res.result?.length > 0){
                setPaymentData(res.result)
            }
          })
          .catch(error=>console.log('Payment history fetching error', error))
          .finally(()=>{
            setIsEmptyModal(false)
          })
      }
  }
  
  const handleModalOpen = () => {
    getHistoryData()
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const renderModalData = () =>{
        return(
            <>
            {[...paymentData].reverse().map(item=><Fragment key={item._id}>
                {!item.appointmentId && item.appType=='IPD' && item.status.toLowerCase()=='success' ? <span class="paymentNotConnected">This Payment not connected with any IPD*</span> :""}
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Date & Time</span>
                    <span className="textReadOnlyValue">{item?._created_at ? handleTimeStamp(item._created_at) :'--' }</span>
                </div>
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Payment Status</span>
                    <span className="textReadOnlyValue" style={{color:item.status ==='Success' ? 'green' : '#393939'}}>{item.status || '--' }</span>
                </div>
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Payment ID / Transaction ID</span>
                    <span className="textReadOnlyValue">{ item.referenceNumber || '--' }</span>
                </div>
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Amount</span>
                    <span className="textReadOnlyValue">{ item.amount || '--'}</span>
                </div>
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Generated By</span>
                    <span className="textReadOnlyValue">{ item.user_name || '--' }</span>
                </div>
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Vendor</span>
                    <span className="textReadOnlyValue">{ item.vendor || '--' }</span>
                </div>
                <Divider sx={{mb:'10px'}}/>
            </Fragment>)}
            </>
        )
  }

  return (
    <div className="textReadOnlyRow">
      <span className="textReadOnlyLabel">Payment History</span>
      <CentralModal
        open={isModalOpen}
        onClose={handleModalClose}
        modalTitle={"Payment History"}
        sx={{ minHeight: "155px" }}
        modalButton={
          <div className="defaultModalButton" onClick={handleModalOpen}>
            View
          </div>
        }
      >
        {isEmptyModal?<div className="summaryModalLoader">
            <CircularProgress fontSize="small" />
          </div>
          : 
          paymentData.length===0 ? <div className="noDataFoundText">No Data Found</div>:
           renderModalData()}
      </CentralModal>
    </div>
  );
};
